
// import { Inertia } from '@inertiajs/vue3';

import { copyToClipboard } from "@helpers";


export {
    refresh,
    link,
    open,
    back,
    scrollTo,

    downloadFile,
    clickForDownload,
}




// recharge la page (avec true -> sans utiliser le cache (direct depuis serveur) mais "deprecated" ! )
const refresh = ()=>{
    // window.location.reload(true); // deprecated, with true,
    // document.location.reload(true); // deprecated, with true,
    // Location.reload(true); // not working
    location.reload();
}


/**
 * Linker Page
 * @param {String} uri
 */
const link = (uri, preserveState = false, replace = false)=>{
    // link: ({uri = '', name = null, params, hash}) => {

// log('in link()', uri, /*$inertia , (proto.prev_uri == proto.acg.$inertia.page.url) */)
//         if(proto.prev_uri && proto.prev_uri == proto.acg.$inertia.page.url){
//             return
//         }




        // if (uri == '' || _.isNull(uri)) { // refresh page
        if (uri == '' || _.isNull(uri) || _.isEmpty(uri)) { // refresh page
        // if ( _.isNull(name) && (uri == '' || _.isNull(uri))) { // refresh page
        //	if(link == ''){ // refresh page
        // router.go({
        //     path: '',
        //     force: true
        // });
        // Inertia.get('')
            // Inertia.visit('', {
            proto.$inertia.visit('', {
                preserveState: preserveState,
                preserveScroll: true,
            })
    } else {
        if (uri.indexOf('mailto') != -1 || uri.indexOf('tel') != -1) {
        // if (url && (url.indexOf('mailto') != -1 || url.indexOf('tel') != -1)) {

            if (uri.indexOf('tel') != -1) {
                if(proto.$_isMobile){
                    uri.replace(/-. /g, ''); //=> 01.23-45 67 89 to 0123456789
                } else {
                    return copyToClipboard(uri.replace(/tel:/g, ''), 'Téléphone')
                }
            }

            return location.assign(uri); //mailto:link or tel:+phoneNumber
        }
// log('Inertia.visit()')

        // if(fn.controlIfFormIsNotDirty(uri, preserveState)){

        //     // proto.acg.$inertia.remember(proto.pp, proto.$page.component)

        //     // proto.acg.$inertia.get(link)
            proto.$inertia.visit(uri, {
                preserveState: preserveState,
                preserveScroll: false,//true,
                replace: replace,
            })
        //     // .then(() => {
        //         // history.replaceState({...history.state, url: proto.prev_uri}, null, proto.prev_uri)
        //     // })

        //     // // router.push({ path: link });
        //     // router.push({name: name, params: params, hash: hash})
        // }
    }

}


/**
 * Open url into a new window
 * @param {String} url
 * @param {String} name
 */
const open = (url, name)=>{

    name = name ? name : url;

    window.open(url, name);
}


const back = ()=>{
    //         // var url = history.state.url

    // //         var url = history.search({
    // //             text: url,
    // //             startTime: 0
    // //           });

    // // log('BACK()', url, window.history);

    // //         if(_.includes(url, 'auth')){

    // //             log('IN');

    // //             history.deleteUrl({url: urlToRemove})

    // //             return fn.back()
    // //         }

    //         // proto.$router.go(-1)

    // log('in link.js - back()',window.history?.state, window.history)

    if( ! _.includes(window.history?.state?.component, 'Auth')){

            window.history.back()
            // window.history.go(-1)

    }


    // log('BACK()', store.state.app.prevUri);

    // acg.$inertia.visit(pp().prevUri)

    // // var url = window.history.previous.href


    // // log(history, url)//, proto.acg.$inertia.prev)

    // // proto.acg.$inertia.visit(url, { preserveScroll: true })
}


/**
 * Scroll to an element
 * @param {Object} anchor ( = id element, dans un div précédent l'élément souhaité)
 * @param {Integer} MyOffset
 */
// import { scroll } from 'quasar'
// const { getScrollTarget, setScrollPosition } = scroll
const scrollTo = (anchor, offset = 10)=>{ //}, MyOffset = 0, duration = 300){

    // fn.showOverlay()

    var el = document.getElementById(_.trim(anchor, '#'));

// log(_.trim(anchor, '#'), el)

    if(el){
        // var app = proto.$store.state.app
        // // app.show_page = false

        // behavior: auto or smooth. Default: auto
        // block: start, center, end, or nearest. Default: start    (Defines vertical alignment)
        // inline: start, center, end, or nearest. Default: nearest (Defines horizontal alignment)
        el.scrollIntoView({
            // behavior: 'smooth',
            offset: offset,
            duration: 50,
        });

        // _.delay(()=>{
        //     app.show_page = true
        // },60)

        // const yOffset = offset;
        // const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        // window.scrollTo({top: y, behavior: 'smooth'});
    }

    //     var scrollEl = document.getElementById(anchor);
    //     const target = getScrollTarget(scrollEl)
    //     // const offset = (target.offsetTop - scrollEl.offsetTop) + MyOffset;
    //     const offset = target.offsetTop;


    //    // let scrollEl = t.closest('.scroll')
    //    // const target = getScrollTarget(el)
    //    // const offset = el.offsetTop - scrollEl.offsetTop
    //    // // const duration = 100
    //    // setScrollPosition(target, offset, duration)

    // fn.hideOverlay()
}


/**
 * Auto Download a file create by PHP (for exportations)
 * @param {Object} response (from php, require: return response()->download($file) )
 */
const downloadFile = (response, filename)=>{

    //	log('in $_downloadFile() helper', response)

    // help: https://stackoverflow.com/questions/50736657/vue-laravel-how-to-properly-download-a-pdf-file
    const url = window.URL.createObjectURL(new Blob([response.data]));

    const link = document.createElement('a');
    link.href = url;
// log(response.headers, response)

	if( ! filename){
		var headers = response.headers
// log(headers)
		if(headers && headers['content-disposition']){
// log(headers['content-disposition'])
			filename = headers['content-disposition'].replace('attachment; filename=', '')
// log(filename)
			var arr_filename = filename.split(';')
// log(arr_filename)
			if(_.size(arr_filename)){
				filename = arr_filename[0]
			}
		}
// log(filename)
	}



    // link.setAttribute('download', _.trim(filename ? filename : response.headers['content-disposition']?.replace('attachment; filename=', '').replace('\\',''), '_')); // filename
    link.setAttribute('download', filename);
    
    document.body.appendChild(link);

    link.click();

    setTimeout(() => {
        window.URL.revokeObjectURL(url) // For Firefox it is necessary to delay revoking the ObjectURL
    }, 100);
}



/**
 * Download file (on CLICK BTN)
 * @param {String} url
 * @param {String} filename
 */
const clickForDownload = (url, filename)=>{

    //log('in $_clickForDownload()', url, filename)

    var url = (_.startsWith(url, 'http') ? '' : '/') + _.trim(url, '/');

    if (filename) {
        window.open(`${url}/${filename}`, filename);
    } else {
        window.open(`${url}`);
    }

    /*
    NE FONCTIONNE QUE POUR DES FICHIEERS SIMPLES, genre .txt
//	axios.post(url, { filename: filename, responseType: 'array_buffer' })
    axios.post(url, { filename: filename, responseType: 'blob' })//, { headers: { "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" } })
        .then((response)=>{

//log('in $_clickForDownload()', response)
//return;

//			var blob = new Blob( [response.data]);//, { type: "application/octet-stream" });
            var blob = new Blob( [response.data], { type: response.headers['content-type'] });
            var url  = URL.createObjectURL(blob);
        //    var url = URL.createObjectURL(new Blob( [file], { type: "application/octet-stream" }));

            const link = document.createElement('a');
            link.href = url;
//			link.setAttribute('download', response.headers['content-disposition'].replace('attachment; filename=', '')); // filename
            link.setAttribute('download', filename);
            document.body.appendChild(link);

            link.click();

            setTimeout(() => {
            window.URL.revokeObjectURL(url)// For Firefox it is necessary to delay revoking the ObjectURL
            }, 100);

        });
        */
}






// export default {


//     refresh_axios: (route)=> {
// // log('in link.js refresh_axios()', fn.route().current(), fn.route().has('login'), fn.route().check('login'), fn.route())

//         // fn.link(route ? route : fn.route(fn.route().current(), fn.pp.item?.id || fn.route().params))
//         fn.link(route ? route : fn.route().current())
//     },



    // contact(){
    //     fn.link('mailto:'+proto.utils?.infos.email+`?subject=[APPLI] Demande Passage Premium - Invité: ${proto.user.name} N°${proto.user.num_societaire}&body=Bonjour`)
    // },


/**
 * Viewer file
 * @param {String} url
 * @param {String} filename
 */
/*proto.$_viewFile = function (url, filename){

//	log('in $_viewFile() helper', file_path)


//	axios.get(file_path);
	axios.post(url, { filename: filename, responseType: 'blob' })
		.then((response)=>{

//		//	const obj_url = window.URL.createObjectURL(blob);
//			const obj_url = window.URL.createObjectURL(new Blob([response.data]));
//
			const id = _.uniqueId('pre_viewer_');
//
			const viewer = document.createElement('iframe');
//			viewer.id = id;
				viewer.setAttribute('id', id);
//
//			const iframe = document.getElementById(id);
////			const iframe = document.getElementByTagName('iframe');
//
//			iframe.setAttribute('src', obj_url);
//
//			window.URL.revokeObjectURL(obj_url);


			let reader  = new FileReader();

			reader.onload = ()=>{
			  var dataURL = url + filename;//reader.result;
//			  var dataURL = response.data;
//			  var output = document.getElementById('output');
			  var output = document.getElementById(id);
			  output.src = dataURL;
			}
			reader.onerror = (stuff) => {
				log("error", stuff)
				log (stuff.getMessage())
			};

			// reader.readAsArrayBuffer(event)
			reader.readAsDataURL(response.data);
		});

};*/

    /**
     * After Login / Logout
     * in Login.vue
     * in auth/actions@logout()
     */
//     deleteHistory:()=>{

// log('in deleteHistory()', proto, history, window.history, navigator)

//         // myHistory.push("page_im_on_now");
//         // window.history.replaceState(myHistory, "<name>", "<url>");

//     //  window.history.deleteAll()
//      var deletingAll = chrome.history.deleteAll();
//      deletingAll.then(onDeleteAll);

// // function onDeleteAll() {
// //   console.log("Deleted all history");
// // }
// // function deleteAllHistory() {
// //   var deletingAll = browser.history.deleteAll();
// //   deletingAll.then(onDeleteAll);
// // }
// // deleteAllHistory();

//             // window.history.deleteUrl({url: this.route('login-view')})

//         // location.replace('/'); // NONONON
//     },


    // route_prev: ()=>{
    //         window.history.go(-1);

    //     // // proto.acg.$inertia.visit(proto.prev_uri, {preserveState: true});

    //     // var prev = proto.prev_uri.pop()

    //     // // log('in prev()', prev, proto.prev_uri)

    //     // proto.acg.$inertia.visit(prev, {preserveState: true, replace: true})
    //     //     // .then((res)=>{
    //     //     //     log('in route_prev()',res)
    //     //     //     proto.acg.$inertia.restore(proto.pp, proto.$page.component)
    //     //     // })

    // },


    // controlIfFormIsNotDirty(uri, preserveState){

    //     if(proto.$store.state.edition.isDirty){

    //         proto.$q.dialog({title: 'Quittez..?',message:'<p>Des modifications ont été apportées.</p>',html:true,
    //                 ok:{label:'Ignorer',color:'grey-8',outline:true, iconRight:'chevron_right'},
    //                 cancel:{label:'Formulaire',color:'primary',flat: true}
    //             }).onOk(()=>{
    //                 proto.$store.state.edition.isDirty = false
    //                 fn.link(uri, preserveState)
    //             }).onCancel(()=>{ return false })
    //     }
    //     else { return true }
    // },



// }
